const account_center = {
    not_enabled: 'アカウントセンターが有効になっていません。',
    field_not_editable: 'フィールドは編集できません。',
};
export default Object.freeze(account_center);
